import React, {useEffect} from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { useAppDispatch, useAppSelector } from './core/hooks';
import { selectLevel, selectStatus, updateUID, updateLevel, userRequestThunk, selectUID, selectLevelNumber } from './core/reducers/reducer-user';
import { getMaxSubscriptionsThunk } from './core/reducers/reducer-subscribed-bias';

import './App.css';
import Header from './components/Header';
import ContentView from './views/ContentView';

function App() {

  const dispatch = useAppDispatch();
  const uid = useAppSelector(selectUID);
  const userStatus = useAppSelector(selectStatus);
  const userLevel = useAppSelector(selectLevel);
  const userLevelNumber = useAppSelector(selectLevelNumber)

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const qUID = queryParams.get('uid');
    if (typeof qUID === "string" ) {
      const uid = parseInt(qUID);       
      dispatch(updateUID(uid)); 
      if (uid === -1111) {
        dispatch(updateLevel("base"));
      } else if (uid === -2222) {
        dispatch(updateLevel("level1"));
      } else {
        dispatch(userRequestThunk(uid));
      }
    } 
  }, []); 

  useEffect(() => {
    if ((uid !== 0) && (uid !== null) && (userStatus !== 'loading') && (userLevelNumber >= 3)) {
      dispatch(getMaxSubscriptionsThunk({level: userLevelNumber}))
    }
  }, [userLevelNumber])

  if (userStatus === "loading") {
    return (
      <div className="App">
        <div className="app-inner">
          <div className="header-cont">
            <Header />
          </div>
          <div className="content-cont">
            <CircularProgress />
          </div>
        </div>
      </div>
    );  
  }

  if (userLevel === "ineligible") {
    return (
      <div className="App">
        <div className="app-inner">
          <div className="header-cont">
            <Header />
          </div>
          <div className="content-cont">
            <div style={{width: '100%', display: "flex", justifyContent: 'center'}}>
              <div style={{marginTop: 32, maxWidth: '60%'}}>
                <div>Your current membership level does not include eligibility for the MCM™.</div> 
                <div>However, if you have recently joined or upgraded to Level 3 or 4, please be informed that the MCM application is currently being activated on your account.</div>
                <div>Should you have any questions regarding access, please contact jason@askslim.com.</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <div className="app-inner">
        <div className="header-cont">
          <Header />
        </div>
        <div className="content-cont">
          <ContentView />
        </div>
      </div>
    </div>
  );
}

export default App;
